<template>
  <div>
    <table class='table_flower' v-viewer>
      <tr>
        <th>
          流水号
        </th>
        <td>
          {{form.applicationNo}}
        </td>
        <th>
          申请业务
        </th>
        <td>
          {{form.applicationTypeText}}
          注销申请人积分、配偶子女信息
        </td>
      </tr>
      <tr>
        <th>
          单位名称
        </th>
        <td>
          {{form.enterpriseName}}
        </td>
        <th>
          社会统一信用代码
        </th>
        <td>
          {{form.enterpriseCode}}
        </td>
      </tr>
      <tr>
        <th>
          人事姓名
        </th>
        <td>
          {{form.personnelName}}
        </td>
        <th>
          人事身份证号
        </th>
        <td>
          {{form.personnelIDCardNo}}
        </td>
      </tr>
      <tr>
        <th>
          人事联系方式
        </th>
        <td colspan="3">
          {{form.personnelPhone}}
        </td>
      </tr>
      <tr>
        <th>
          注销对象类型
        </th>
        <td :colspan="form.logoutObjectType===1?'3':'1'">
          {{form.logoutObjectTypeText}}

        </td>
        <template v-if="form.logoutObjectType===5">
          <th>
            已选需注销对象
          </th>
          <td>
            <span v-if="form.isLogoutChildren">子女</span>
            <span v-if="form.isLogoutChildren&&form.isLogoutSpouse">、</span>
            <span v-if="form.isLogoutSpouse">配偶</span>
          </td>
        </template>
      </tr>
      <tr>
        <th>
          申请人身份证人像面
        </th>
        <td>
          <img :src="$baseURL + '/file/preview/'+form.applicantIDCardFrontGuid" fit="fill" width="100px" height="100px" />
        </td>
        <th>
          申请人身份证国徽面
        </th>
        <td>
          <img :src="$baseURL + '/file/preview/'+form.applicantIDCardBackGuid" fit="fill" width="100px" height="100px" />
        </td>
      </tr>
      <tr>
        <th>
          申请人姓名
        </th>
        <td>
          {{form.applicantName}}
        </td>
        <th>
          申请人身份证号
        </th>
        <td>
          {{form.applicantIDCardNo}}
        </td>
      </tr>
      <tr>
        <th>
          户籍类型
        </th>
        <td>
          {{form.applicantRegisteredResidenceTypeText}}
        </td>
        <template v-if="form.applicantRegisteredResidenceType==$store.state.registeredResidenceType['集体户口']">
          <th>
            集体户口类型
          </th>
          <td>
            {{form.applicantCollectiveAccountMaterialsTypeText}}
          </td>
        </template>
      </tr>
      <tr
        v-if="form.applicantRegisteredResidenceType==$store.state.registeredResidenceType['家庭户口']||(form.applicantRegisteredResidenceType==$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType==$store.state.collectiveAccountMaterialsTypes['户口簿'])">
        <th>
          户口簿详细地址页的首页
        </th>
        <td>
          <img :src="$baseURL + '/file/preview/'+form.applicantResidenceBookletMainPageGuid" fit="fill" width="100px" height="100px" />
        </td>
        <th>
          户口簿本人信息页
        </th>
        <td>
          <img :src="$baseURL + '/file/preview/'+form.applicantResidenceBookletSelfPageGuid" fit="fill" width="100px" height="100px" />
        </td>
      </tr>

      <tr>
        <template v-if="(form.applicantRegisteredResidenceType==$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType==$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明'])">
          <th>
            派出所出具的户籍证明
          </th>
          <td>
            <img :src="$baseURL + '/file/preview/'+form.applicantPoliceStationRegistrationCertificateGuid" fit="fill" width="100px" height="100px" />
          </td>
        </template>
        <th>
          申请人联系方式
        </th>
        <td>
          {{form.applicantPhone}}
        </td>
      </tr>
      <tr>
        <th>
          申请人居住证正面
        </th>
        <td>
          <img :src="$baseURL + '/file/preview/'+form.applicantResidencePermitFrontGuid" fit="fill" width="100px" height="100px" />
        </td>
        <th>
          居住证有效期
        </th>
        <td colspan="3">
          {{form.applicantResidencePermitExpiryDate}}
        </td>
        <!-- <th>
          上传申请人居住证反面
        </th>
        <td>
          <img :src="$baseURL + '/file/preview/'+form.applicantResidencePermitBackGuid" fit="fill" width="100px" height="100px" />
        </td> -->
      </tr>
      <!-- <tr>
        <th>
          居住证有效期
        </th>
        <td colspan="3">
          {{form.applicantResidencePermitExpiryDate}}
        </td>
      </tr> -->
      <!-- 配偶 -->
      <template v-if="form.logoutObjectType==$store.state.logoutObjectTypeList.find(el=>{return el.text=='配偶/子女'}).value&&form.isLogoutSpouse">
        <!-- <tr>
          <th colspan="4" style="color:#1890ff;text-align:center;">配偶信息
          </th>
        </tr> -->
        <tr>
          <th>
            配偶身份证人像面
          </th>
          <td>
            <img :src="$baseURL + '/file/preview/'+form.applicantIDCardFrontGuid" fit="fill" width="100px" height="100px" />
          </td>
          <th>
            配偶身份证国徽面
          </th>
          <td>
            <img :src="$baseURL + '/file/preview/'+form.applicantIDCardBackGuid" fit="fill" width="100px" height="100px" />
          </td>
        </tr>
        <tr>
          <th>
            配偶姓名
          </th>
          <td>
            {{form.spouse.name}}
          </td>
          <th>
            配偶身份证号
          </th>
          <td>
            {{form.spouse.idCardNo}}
          </td>
        </tr>
        <tr>
          <th>
            户籍类型
          </th>
          <td>
            {{form.spouse.registeredResidenceTypeText}}
          </td>
          <template v-if="form.spouse.registeredResidenceType==$store.state.registeredResidenceType['集体户口']">
            <th>
              集体户口类型
            </th>
            <td>
              {{form.spouse.collectiveAccountMaterialsTypeText}}
            </td>
          </template>
        </tr>
        <tr
          v-if="form.spouse.registeredResidenceType==$store.state.registeredResidenceType['家庭户口']||(form.spouse.registeredResidenceType==$store.state.registeredResidenceType['集体户口']&&form.spouse.collectiveAccountMaterialsType==$store.state.collectiveAccountMaterialsTypes['户口簿'])">
          <th>
            户口簿详细地址页的首页
          </th>
          <td>
            <img :src="$baseURL + '/file/preview/'+form.spouse.residenceBookletMainPageGuid" fit="fill" width="100px" height="100px" />
          </td>
          <th>
            户口簿本人信息页
          </th>
          <td>
            <img :src="$baseURL + '/file/preview/'+form.spouse.residenceBookletSelfPageGuid" fit="fill" width="100px" height="100px" />
          </td>
        </tr>

        <tr>
          <template v-if="(form.spouse.registeredResidenceType==$store.state.registeredResidenceType['集体户口']&&form.spouse.collectiveAccountMaterialsType==$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明'])">
            <th>
              派出所出具的户籍证明
            </th>
            <td>
              <img :src="$baseURL + '/file/preview/'+form.spouse.policeStationRegistrationCertificateGuid" fit="fill" width="100px" height="100px" />
            </td>
          </template>
          <th>
            持证人结婚证原件
          </th>
          <td>
            <img :src="$baseURL + '/file/preview/'+form.spouse.marriageCertificateGuid" fit="fill" width="100px" height="100px" />
          </td>
        </tr>
      </template>
      <!-- 子女 -->
      <template v-if="form.logoutObjectType==$store.state.logoutObjectTypeList.find(el=>{return el.text=='配偶/子女'}).value&&form.isLogoutChildren">
        <tbody v-for="(children,index) in form.childrenList" :key="index">
          <tr>
            <th>
              子女{{index+1}}姓名
            </th>
            <td>
              {{children.name}}
            </td>
            <th>
              子女{{index+1}}身份证号
            </th>
            <td>
              {{children.idCardNo}}
            </td>
          </tr>
          <tr>

            <th>
              子女{{index+1}}年龄
            </th>
            <td colspan="3">
              {{children.age}}
            </td>
          </tr>
          <tr>
            <th>
              子女{{index+1}}户籍
            </th>
            <td>
              {{children.registeredResidenceTypeText}}
            </td>
            <template v-if="children.registeredResidenceType==$store.state.registeredResidenceType['集体户口']">
              <th>
                集体户口类型
              </th>
              <td>
                {{children.collectiveAccountMaterialsTypeText}}
              </td>
            </template>
          </tr>
          <tr
            v-if="children.registeredResidenceType==$store.state.registeredResidenceType['家庭户口']||(children.registeredResidenceType==$store.state.registeredResidenceType['集体户口']&&children.collectiveAccountMaterialsType==$store.state.collectiveAccountMaterialsTypes['户口簿'])">
            <th>
              子女{{index+1}}户口簿详细地址页的首页
            </th>
            <td>
              <img :src="$baseURL + '/file/preview/'+children.residenceBookletMainPageGuid" fit="fill" width="100px" height="100px" />
            </td>
            <th>
              子女{{index+1}}户口簿本人信息页
            </th>
            <td>
              <img :src="$baseURL + '/file/preview/'+children.residenceBookletSelfPageGuid" fit="fill" width="100px" height="100px" />
            </td>
          </tr>

          <tr>
            <template v-if="(children.registeredResidenceType==$store.state.registeredResidenceType['集体户口']&&children.collectiveAccountMaterialsType==$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明'])">
              <th>
                派出所出具的户籍证明
              </th>
              <td>
                <img :src="$baseURL + '/file/preview/'+children.policeStationRegistrationCertificateGuid" fit="fill" width="100px" height="100px" />
              </td>
            </template>
            <th>
              子女{{index+1}}出生医学证明原件
            </th>
            <td>
              <img :src="$baseURL + '/file/preview/'+children.birthCertificateGuid" fit="fill" width="100px" height="100px" />
            </td>
          </tr>
        </tbody>
      </template>
      <tr>
        <th>
          注销申请人积分、配偶子女信息申请表
        </th>
        <td colspan="3">
          <div class="_link" v-for="item in form.logoutApplicationFormGuidPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.logoutApplicationFormGuidPreview.length<1">无</span>
        </td>
      </tr>
      <tr>
        <th>
          其他材料
        </th>
        <td colspan="3">
          <div class="_link" v-for="item in form.otherFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.otherFileGuidListPreview.length<1">无</span>
        </td>
      </tr>

      <tr>
        <th>
          提交时间
        </th>
        <td>
          {{ form.submitTimeText}}
        </td>
        <th>
          状态
        </th>
        <td>
          {{ form.statusText}}
        </td>
      </tr>

    </table>
  </div>
</template>
<script>
export default {
  props: { form: Object },
  methods: {
    handlePreview(url) {
      this.$emit('handlePreview', url)
    },
  },
}
</script>